import moment from 'moment';
//import Swal from "sweetalert2";
import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';
export default {
    name: 'Financial',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (!this.requireUserType([1])) return;

        this.GetInfo();
        await this.GetAllPaymentMethods();
        await this.GetAllFinancialsWithdrawing();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('DD/MM/YYYY');
        },

        momentTime: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('DD/MM/YYYY || HH:MM');
        }
    },
    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            state: 0,
            Search: '',

            ScreenTitle: '  حركات الحسابات ',
            ScreenTitleSingle: '  حركة   ',
            ScreenTitleSingleAl: ' حركة  ',

            Info: [],
            Statistics: [],

            AddDialog: false,

            SelectedItem: '',

            From: '',
            To: '',
            FilterBy: 1,
            PaymentMethodsId: '',
            WithdrawingId: '',
            Operation: '',

            // P0-4 (audit 2026-05-26): manual financial-transaction (ledger) form.
            // A row is سحب/إيداع on the Financials ledger — it does NOT move a
            // wallet balance. Band (WithdrawingId) + Value are required; the
            // beneficiary user and payment method are optional.
            ruleForm: {
                Id: '',
                UserId: null,
                PaymentMethodsId: null,
                WithdrawingId: null,
                Value: null,
                Descriptions: '',
            },
            rules: {
                WithdrawingId: this.$helper.Required(),
                Value: this.$helper.Required(),
            },
        };
    },



    methods: {

        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (this.From)
                this.From = this.ChangeDate(this.From);

            if (this.To)
                this.To = this.ChangeDate(this.To);

            if (!this.Search)
                this.$blockUI.Start();
            this.$http.GetWithdrawingTracker(this.pageNo, this.pageSize, this.Search, this.From, this.To,
                this.PaymentMethodsId, this.WithdrawingId, this.Operation)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                    this.Statistics = response.data.statistics;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },


        ChangeFilter(id) {
            this.FilterBy = id;
            this.PaymentMethodsId = '';
            this.WithdrawingId = '';
            this.Operation = '';
        },


        Refresh() {
            this.PaymentMethodsId = '';
            this.WithdrawingId = '';
            this.Operation = '';
            this.From = '';
            this.To = '';
            this.GetInfo();
        },

        // -------- P0-4: manual financial-transaction Add/Edit (super-admin) --------
        OpenAddDialog() {
            this.ClearForm(this.ruleForm);
            this.SelectedItem = '';
        },

        submitForm(formName) {
            const form = this.$refs[formName];
            if (!form) return;
            form.validate((valid) => {
                if (!valid) { this.$helper.showSwal('warning'); return; }
                this.ruleForm.Id = Number(0);
                this.$blockUI.Start();
                this.$http.AddFinancial(this.ruleForm)
                    .then(response => {
                        this.$blockUI.Stop();
                        this.GetInfo(this.pageNo);
                        this.ClearForm(this.ruleForm);
                        this.$helper.DestroyElemntById('CloseAdd');
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ بعملية الإضافة', err.response && err.response.data ? err.response.data : 'حدث خطأ');
                    });
            });
        },

        OpentEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm.Id = item.id;
            this.ruleForm.UserId = item.userId || null;
            this.ruleForm.PaymentMethodsId = item.paymentMethodsId || null;
            this.ruleForm.WithdrawingId = item.withdrawingId || null;
            this.ruleForm.Value = item.value;
            this.ruleForm.Descriptions = item.descriptions || '';
        },

        submitEditForm(formName) {
            const form = this.$refs[formName];
            if (!form) return;
            form.validate((valid) => {
                if (!valid) { this.$helper.showSwal('warning'); return; }
                this.ruleForm.Id = Number(this.ruleForm.Id);
                this.$blockUI.Start();
                this.$http.EditFinancial(this.ruleForm)
                    .then(response => {
                        this.$blockUI.Stop();
                        this.GetInfo(this.pageNo);
                        this.ClearForm(this.ruleForm);
                        this.$helper.DestroyElemntById('CloseEdit');
                        this.$helper.ShowMessage('success', 'عملية ناجحة', response.data);
                    })
                    .catch((err) => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage('error', 'خطأ بعملية التعديل', err.response && err.response.data ? err.response.data : 'حدث خطأ');
                    });
            });
        }

    }
}
